import { render } from "./toolbar_button.vue?vue&type=template&id=712e2412&scoped=true&lang=pug"
import script from "./toolbar_button.vue?vue&type=script&lang=js"
export * from "./toolbar_button.vue?vue&type=script&lang=js"

import "./toolbar_button.vue?vue&type=style&index=0&id=712e2412&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712e2412"]])

export default __exports__